"use client";

import { useMemo } from "react";

import type { Medium, TrackVideo } from "@/components/tracklist";

export interface PlaylistTrack {
  youtubeId: string;
  trackTitle: string;
}

export function useTrackVideoPlaylist(media: Medium[], trackVideos: TrackVideo[]): PlaylistTrack[] {
  return useMemo(() => {
    const trackVideosByTrackId = new Map(
      trackVideos.map((trackVideo) => [trackVideo.trackId, trackVideo]),
    );

    return media.flatMap((medium) =>
      medium.tracks.flatMap((track) => {
        const youtubeId = trackVideosByTrackId.get(track.id)?.youtubeId;
        if (!youtubeId) return [];
        return [{ youtubeId, trackTitle: track.title }];
      }),
    );
  }, [media, trackVideos]);
}
